module.exports = __webpack_public_path__ + "img/collection-weddingRingsPalladium.27a03d1.webp";